interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | string)[] {
  const pages: (number | string)[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (page > 3) pages.push("...");
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (page < totalPages - 2) pages.push("...");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="hidden md:flex items-center justify-center gap-2 mt-8">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:bg-background-100 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" /> 上一页
      </button>

      {buildPages(page, totalPages).map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-md text-sm font-medium cursor-pointer transition-colors ${
              p === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:bg-background-100"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="w-9 h-9 flex items-center justify-center text-foreground-400">
            ...
          </span>
        )
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:bg-background-100 cursor-pointer"
      >
        下一页 <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}